/**
 * @author Andrés Ferreira
 * @Copyright (c) Infotrack. All rights reserved.
 */
import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import RefreshIcon from '@material-ui/icons/Refresh';
import { Action, Column, Options } from '@infotrack/presentacion-componentes/tabla';
import { TipoFormulario } from '@infotrack/presentacion-transversales/interfacesComunes';
import IResolucionesFacturaciones from 'Infotrack@Modelos/smartStock/resolucionesFacturaciones/entidades/resolucionesFacturaciones';
import { BotonAgregar, BotonRefrescar } from 'Infotrack@Transversales/componentes/botonesAcciones';
import moment from 'moment';
import React from 'react';
import { FormattedMessage } from 'react-intl';

export const columnas = (
    formatMessage: (params: FormattedMessage.MessageDescriptor) => string
): Array<Column<IResolucionesFacturaciones>> => [
    {
        title: formatMessage({ id: 'resolucionesFacturaciones.descripcionResolucionFacturacion' }),
        field: 'DescripcionResolucionFacturacion',
    },
    {
        title: formatMessage({ id: 'resolucionesFacturaciones.facturaInicio' }),
        field: 'FacturaInicio',
    },
    {
        title: formatMessage({ id: 'resolucionesFacturaciones.facturaFin' }),
        field: 'FacturaFin',
    },
    {
        title: formatMessage({ id: 'resolucionesFacturaciones.facturaActual' }),
        field: 'FacturaActual',
    },
    {
        title: formatMessage({ id: 'resolucionesFacturaciones.fechaInicio' }),
        field: 'FechaInicio',
        render: ({ FechaInicio }) => moment(FechaInicio).format('DD/MM/YYYY/hh:mm A'),
    },
    {
        title: formatMessage({ id: 'resolucionesFacturaciones.fechaFin' }),
        field: 'FechaFin',
        render: ({ FechaFin }) => moment(FechaFin).format('DD/MM/YYYY/hh:mm A'),
    },
    {
        title: formatMessage({ id: 'resolucionesFacturaciones.estado' }),
        field: 'Estado',
        type: 'boolean',
    },
];

export const acciones = (
    manejarFormulario: (tipoFormulario: TipoFormulario, resolucionesFacturaciones?: IResolucionesFacturaciones) => void,
    cargarResolucionesFacturaciones: () => void,
    formatMessage: (params: FormattedMessage.MessageDescriptor) => string,
    confirmarEliminacion: (resolucionesFacturaciones: IResolucionesFacturaciones) => void
): Array<Action<IResolucionesFacturaciones>> => [
    {
        component: BotonAgregar,
        icon: () => <AddIcon id="Icono-Agregar"/>,
        onClick: () => manejarFormulario(TipoFormulario.Creacion, undefined),
        isFreeAction: true,
        tooltip: formatMessage({ id: 'boton.agregar' }),
    },
    {
        icon: () => <EditIcon id="Icono-Editar" color="action" />,
        onClick: (_, value) => manejarFormulario(TipoFormulario.Edicion, value as IResolucionesFacturaciones),
        tooltip: formatMessage({ id: 'boton.editar' }),
    },
    {
        component: BotonRefrescar,
        icon: () => <RefreshIcon id="Icono-Refrescar"/>,
        onClick: cargarResolucionesFacturaciones,
        isFreeAction: true,
        tooltip: formatMessage({ id: 'boton.refrescar' }),
    },
    {
        icon: () => <DeleteIcon id="Icono-Eliminar" color="action" />,
        onClick: (_, value) => confirmarEliminacion(value as IResolucionesFacturaciones),
        tooltip: formatMessage({ id: 'boton.eliminar' }),
    },
];

export const opciones: Options<IResolucionesFacturaciones> = {
    maxBodyHeight: '50vh',
};
